@if (isTemplatePrint() || visibleRecords().length > 0) {
  <div class="laser-print-header print-header">
    <div class="header">
      <div class="title">
        <div class="title-text">Laser</div>
      </div>
      <span class="message">* populated from PatientNow</span>
    </div>
    <hr class="divider" />
  </div>

  <div class="laser-print-records">
    @if (isTemplatePrint() && visibleRecords().length === 0) {
      <div class="laser-print-record">
        <fb-laser-treatment-control-display isPrinting />
      </div>
    } @else {
      @for (record of visibleRecords(); track $index; let last = $last) {
        <div class="laser-print-record">
          <fb-laser-treatment-control-display
            [value]="record.item"
            [labels]="record.labels"
            [markerTarget]="record.markerTarget"
            isPrinting
          />
        </div>
        @if (!last) {
          <hr class="divider" />
        }
      }
    }
  </div>
}
